/**
 * Actions for Dialysis tube Predictions
 *
 * This file contains action creators related to the management of dialysis tube predictions.
 * Action creators are functions that create and return action objects to be dispatched to the Redux store.
 */

/**
 * Action Creator: onDialysisSelect
 *
 * Description:
 * Sets the dialysis tube in prediction to an active state in the store.
 *
 * @param {object} data - The dialysis tube prediction data.
 * @returns {object} - The action object with type and payload.
 */
export const onDialysisSelect = (data) => {
  return { type: "ON_DIALYSIS_SELECT", payload: data };
};

/**
 * Action Creator: onDialysisUpdate
 *
 * Description:
 * Updates the dialysis tube in prediction state in the store.
 *
 * @param {object} data - The dialysis tube prediction data.
 * @returns {object} - The action object with type and payload.
 */
export const onDialysisUpdate = (data) => {
  return { type: "ON_DIALYSIS_UPDATE", payload: data };
};

/**
 * Action Creator: onDialysisResultUpdate
 *
 * Description:
 * Updates the dialysis tube in result state in the store.
 *
 * @param {object} data - The dialysis tube result data.
 * @returns {object} - The action object with type and payload.
 */
export const onDialysisResultUpdate = (data) => {
  return { type: "ON_DIALYSIS_RESULT_UPDATE", payload: data };
};

/**
 * Action Creator: onDialysisSubmit
 *
 * Description:
 * Saves the dialysis tube in prediction state submission in the store.
 *
 * @param {object} data - The dialysis tube prediction data.
 * @returns {object} - The action object with type and payload.
 */
export const onDialysisSubmit = (data) => {
  return { type: "ON_DIALYSIS_SUBMIT", payload: data };
};

/**
 * Action Creator: onDialysisReset
 *
 * Description:
 * Resets the dialysis tube prediction state in the store.
 *
 * @param {object} data - The dialysis tube prediction data.
 * @returns {object} - The action object with type and payload.
 */
export const onDialysisReset = (data) => {
  return { type: "ON_DIALYSIS_RESET", payload: data };
};

/**
 * Action Creator: onCloseFeedback
 *
 * Description:
 * Closes the dialysis tube prediction state feedback in the store.
 *
 * @param {object} data - The dialysis tube prediction data.
 * @returns {object} - The action object with type and payload.
 */
export const onCloseFeedback = (data) => {
  return { type: "CLOSE_FEEDBACK", payload: data };
};
